import { ApiService } from "@/services/api/ApiService";
import type { SessionDetailResponse, SessionListResponse, ToolInvocation } from "@/types/brain/session";

export class SessionService {
  static async getSessions(
    userId: string,
    options: { limit?: number; offset?: number; search?: string } = {},
  ): Promise<SessionListResponse> {
    return ApiService.invoke<SessionListResponse>({
      resource: "sessions",
      action: "list",
      data: {
        userId,
        limit: options.limit,
        offset: options.offset,
        search: options.search,
      },
    });
  }

  static async getSessionDetail(sessionId: string, userId: string): Promise<SessionDetailResponse> {
    return ApiService.invoke<SessionDetailResponse>({
      resource: "sessions",
      action: "get",
      id: sessionId,
      data: { userId },
    });
  }

  static async getUnlinkedInvocations(userId: string): Promise<{ invocations: ToolInvocation[] }> {
    return ApiService.invoke<{ invocations: ToolInvocation[] }>({
      resource: "sessions",
      action: "list-unlinked-invocations",
      data: { userId },
    });
  }

  static async deleteUnlinkedInvocation(invocationId: string, userId: string): Promise<{ deleted: number }> {
    return ApiService.invoke<{ deleted: number }>({
      resource: "sessions",
      action: "delete-unlinked-invocation",
      id: invocationId,
      data: { userId },
    });
  }

  static async deleteAllUnlinkedInvocations(userId: string): Promise<{ deleted: number }> {
    return ApiService.invoke<{ deleted: number }>({
      resource: "sessions",
      action: "delete-all-unlinked-invocations",
      data: { userId },
    });
  }
}
